import { useMutation } from '@tanstack/react-query'
import { api } from '../../api'
import { CreatePaymentParams } from '../../types/payment.type'

export const useCreatePayment = () =>
  useMutation({
    mutationFn: (params: CreatePaymentParams) => api.createPayment(params),
    mutationKey: ['create-payment'],
  })
